import React from 'react';
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

interface Props {
	value: number;
	showLarge?: boolean;
}

const MatchPercentageCircularBar = ({ value, showLarge }: Props) => {
	return (
		<div className=" @3xl/profile-introduction:max-w-[100px] @3xl/profile-introduction:max-h-[56px] @4xl/profile-introduction:max-w-[120px] @4xl/profile-introduction:max-h-[56px]">
			<div className="flex flex-col items-center text-center">
				<div className="max-w-[75px] max-h-[75px]">
					<CircularProgressbarWithChildren
						styles={buildStyles({
							pathColor: value < 500 ? '#FFCC00' : value >= 500 && value < 750 ? '#FF8800' : '#06C270',
							trailColor: '#555770',
							strokeLinecap: 'round',
							pathTransitionDuration: 1,
							rotation: 0.75,
						})}
						strokeWidth={showLarge ? 13 : 11}
						maxValue={1000}
						circleRatio={0.5}
						value={value}
					>
						<div className="w-full h-full relative p-3 text-center">
							<div className="flex items-center justify-center">
								<p className="text-md mt-2 @3xl/profile-introduction:text-lg @4xl/profile-introduction:text-xl font-inter font-[700]">
									{Math.round(value)}
								</p>
							</div>
						</div>
					</CircularProgressbarWithChildren>
				</div>
				<p className="text-[#8F90A6] text-[12px] -mt-7 font-[500] font-inter">
					{value < 200 ? 'Need Training' : value >= 200 && value < 500 ? 'Need Practice' : 'Good Fit'}
				</p>
			</div>
		</div>
	);
};

export default MatchPercentageCircularBar;
